import { ConectoresTemplate, ConectoresTemplateCadastro, ConectoresTemplateGrupo, ConectoresTemplateGrupoCadastro } from '@containers';
import { InfoUsuario } from '@utils';

const getPermissaoFila = (infoUsuario) => InfoUsuario.perm('admin') || InfoUsuario.perm('fila');

export default [
  {
    path: '/conectores/templates/grupo',
    parent: '/conectores',
    text: 'Templates',
    sider: true,
    component: ConectoresTemplateGrupo,
    secret: true,
    exact: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
  {
    path: '/conectores/templates/grupo/cadastro/:id',
    text: 'Cadastro de Grupo de Template',
    component: ConectoresTemplateGrupoCadastro,
    secret: true,
    exact: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },

  {
    path: '/conectores/templates/:idGrupo',
    text: 'Templates',
    component: ConectoresTemplate,
    secret: true,
    exact: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
  {
    path: '/conectores/templates/cadastro/:idGrupo/:id',
    text: 'Cadastro de Template',
    component: ConectoresTemplateCadastro,
    secret: true,
    exact: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
];
